import React, { useEffect, useState } from "react";
import { Timestamps, colors } from "../utils/constants";
// import { parse, isValid, format, isAfter, isBefore } from 'date-fns';
// import { enAU } from 'date-fns/locale';
// import { db } from "../firebase-config";
// import { addDoc, collection, doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../components/Modal";
import BackButton from '../assets/Back.png'
import { clearBookings } from "../redux/bookingReducer";
import { useDispatch } from "react-redux";
import { isAfter } from "date-fns";

const PickDate = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [date, setDate] = useState(false)
    const [showConfirmationBack, setShowConfirmationBack] = useState(false)


    useEffect(() => {
        const userId = window.localStorage.getItem('config:userId')
        if (!userId && window.location.pathname !== '/') {
            navigate('/')
        }
    }, [])

    return (<div className="container">
        <h2 style={{ margin: '50px auto 0', color: colors.red }}>Choose your date</h2>

        <div tabIndex={0}>
            <img src={BackButton} className="back-button" onClick={() => setShowConfirmationBack(true)} />
        </div>

        <ModalComponent showModal={!!showConfirmationBack} setShowModal={setShowConfirmationBack}>
            <>
                <h2 style={{ textAlign: 'center' }}>Are you sure you want to cancel your current booking and start again?</h2>
                <p style={{ textAlign: 'center', marginTop: 0 }}>You would have to register your child again.</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button onClick={() => { dispatch(clearBookings()); window.localStorage.removeItem('config:userId'); setTimeout(() => navigate(`/`), 100) }}>Confirm</button>
                    <button className="secondary-button" onClick={() => { setShowConfirmationBack(false) }}>Cancel</button>
                </div>
            </>
        </ModalComponent>
        <ModalComponent showModal={!!date} setShowModal={setDate}>
            <>
                <p style={{ textAlign: 'center' }}>Please note:</p>
                <p style={{ margin: '5px 0 0' }}>
                    - Child is limited to one booking per ride.
                </p>
                <p style={{ margin: '5px 0 0' }}>
                    - You must leave at least 30 minutes between each ride.
                </p>
                <p style={{ margin: '5px 0 0' }}>
                    - Admission onto rides is subject to meeting necessary minimum and maximum height and weight requirements on the day
                </p>
                <div style={{ display: 'flex' }}>
                    <button onClick={() => { navigate(`/selectRide?dt=${date}`); setDate(false) }}>Accept</button>
                </div></>
        </ModalComponent>

        <button disabled={isAfter(new Date(), new Date(Timestamps.Saturday))} onClick={() => setDate('29')}> Saturday, 29th Jul</button>
        <button disabled={isAfter(new Date(), new Date(Timestamps.Sunday))} onClick={() => setDate('30')}> Sunday, 30th Jul</button>

    </div>)
}

export default PickDate